import { api } from '@/lib/axios-client'
import type { AltaVsTitleReport } from '../types/alta-vs-title-types'
import { getCheckProgressBySubmittal } from './site-plan-jobs-api'
import {
  ALTA_VS_TITLE_DISPLAY_NAME,
  isAltaVsTitleDisplayName,
} from '@/features/city-clerk/shared/constants/qc-check-constants'

export { ALTA_VS_TITLE_DISPLAY_NAME }

const TERMINAL_CHECK_STATUSES = new Set([
  'CompletedSuccessfully',
  'CompletedWithFailures',
  'Failed',
  'Cancelled',
])

export type AltaVsTitleCheckSummary = {
  checkId: string
  status: string
  isDone: boolean
  isFailed: boolean
}

export const getAltaVsTitleCheckSummary = async (
  permitSubmittalId: string,
): Promise<AltaVsTitleCheckSummary | null> => {
  const snapshots = await getCheckProgressBySubmittal(permitSubmittalId)
  const snapshot = snapshots?.find((s) =>
    isAltaVsTitleDisplayName(s.displayName),
  )
  if (!snapshot?.checkId) return null

  return {
    checkId: snapshot.checkId,
    status: snapshot.status,
    isDone: TERMINAL_CHECK_STATUSES.has(snapshot.status),
    isFailed: snapshot.status === 'Failed',
  }
}

export const getAltaVsTitleReportByAttachmentId = async (
  attachmentId: string,
): Promise<AltaVsTitleReport | null> => {
  const response = await api.get<AltaVsTitleReport | null>(
    `/Qc/AltaTitle/by-attachment/${attachmentId}/report`,
    { meta: { handle404: 'ignore' } } as never,
  )
  return response ?? null
}

export const getAltaVsTitleResult = async (
  checkId: string,
): Promise<AltaVsTitleReport | null> => {
  const response = await api.get<AltaVsTitleReport | null>(
    `/Qc/AltaTitle/${checkId}/report`,
    { meta: { handle404: 'ignore' } } as never,
  )
  return response ?? null
}

type RenderDocxResponse = { downloadUrl: string }

export const renderAltaTitleDocx = async (
  checkId: string,
): Promise<string | null> => {
  const response = await api.post<RenderDocxResponse>(
    `/Qc/AltaTitle/${checkId}/render-docx`,
  )
  return response?.downloadUrl ?? null
}
